/*
* 存储相关函数
* */
'use strict';

exports.get = function (k) {
  try {
    return window.localStorage[k];
  } catch (e) {
    console.error(e);
    return '';
  }
};

exports.set = function (k, v) {
  try {
    window.localStorage[k] = v;
  } catch (e) {
    console.error(e);
  }
};


// WEBPACK FOOTER //
// ./src/helper/storeHelper.js